let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5x6Gz")).then(() => parcelRequire('1BNgi'));